import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Checkbox } from 'semantic-ui-react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import UserGroupPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/UserGroupPanelContainer';
import UserGroupName from './UserGroupName';
import UserGroupDescription from './UserGroupDescription';
import UsergroupPanelAccordion from '../components/UsergroupPanelAccordion';

const UserGroupPanelNarrow = ({
  bpmn,
  canCreate,
  canRead,
  category,
  code,
  description,
  fetchGroup,
  isDirty,
  isDuplicate,
  isEditing,
  isNew,
  name,
  newGroup,
  panels,
  onChange,
  readErrors,
  readStatus,
  saveErrors,
  updatePanels,
  updateProperties,
  url,
}) => {
  const intl = useIntl();
  return (
    <UserGroupPanelContainer
      canCreate={canCreate}
      canRead={canRead}
      category={category}
      code={code}
      description={description}
      fetchGroup={fetchGroup}
      isDirty={isDirty}
      isDuplicate={isDuplicate}
      isNew={isNew}
      name={name}
      newGroup={newGroup}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      url={url}
    >
      <div className="aridhia-usergroup-panel-full">
        <EntitiesErrorMessages
          category={category}
          code={code}
          entity="usergroup"
          errors={saveErrors}
          onDismiss={(errors) => updateProperties(category, code, { saveErrors: errors })}
        />
        <UserGroupName code={code} category={category} />
        <UserGroupDescription code={code} category={category} />
        {isEditing && (
          <Checkbox
            className="mt-10"
            checked={bpmn}
            toggle
            label={intl.formatMessage({ id: 'usergroup.bpmn' })}
            onClick={() => updateProperties(category, code, { bpmn: !bpmn })}
          />
        )}
        {(!isEditing || isDuplicate) && (
          <UsergroupPanelAccordion
            category={category}
            code={code}
            isDuplicate={isDuplicate}
            panels={panels}
            updatePanels={updatePanels}
          />
        )}
      </div>
    </UserGroupPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupPanelNarrow);
